export const FILTER_ACTION_BUTTON_CLASSES = {
  desktop:
    "relative flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-black bg-white text-[#475467] shadow-[0_4px_0_0_black] transition-all duration-150 hover:bg-[#F9FAFB] hover:text-[#101828] active:translate-y-[4px] active:shadow-none",
  mobile:
    "relative flex h-[54px] w-[52px] shrink-0 items-center justify-center rounded-lg border border-[#667085] bg-white shadow-[0px_4px_0px_0px_#000000] transition-colors hover:bg-gray-50 sm:h-[56px] sm:w-[72px]",
};

export const FILTER_ACTION_BADGE_CLASSES = {
  desktop: "-right-1 -top-1 bg-[#ED5AA9]",
  mobile:
    "-right-1.5 -top-1.5 border border-black bg-[#FF60B5] shadow-[1px_1px_0px_0px_#000000]",
};
